import Icon from '../components/Icon.vue'

Icon.register({"arrow-alt-circle-up":{"width":512,"height":512,"paths":[{"d":"M8 256C8 119 119 8 256 8S504 119 504 256 393 504 256 504 8 393 8 256zM300 372V256H370.9C381.6 256 387 243 379.4 235.5L264.5 121.2C259.8 116.5 252.3 116.5 247.6 121.2L132.6 235.5C125 243.1 130.4 256 141.1 256H212V372C212 378.6 217.4 384 224 384H288C294.6 384 300 378.6 300 372z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/arrow-alt-circle-up.js
// module id = reyi
// module chunks = 0